module.exports = __webpack_public_path__ + "static/media/piece-15.46839335.png";